import { Clonable } from '../../..';

export class TeamTag extends Clonable {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly isActive: boolean,
  ) {
    super();
  }

  static sort(a: TeamTag, b: TeamTag): number {
    if (a.isActive === b.isActive) {
      return a.name.localeCompare(b.name);
    }

    return a.isActive ? -1 : 1;
  }
}
